import {isString} from 'ramda-adjunct';

import {
  UpdateWatermarkRequestBody,
  UpdateWatermarkV2RequestBody,
  WatermarkPositionEnum,
} from '@dms/api/shared';

import {WatermarkFormType, WatermarkFormTypeOld} from '../types/watermarkForm';

export const getRequestData = (data: WatermarkFormType): UpdateWatermarkV2RequestBody => ({
  name: data.name,
  size: data.size,
  position: data.position as WatermarkPositionEnum,
  fitToImage: data.fitToImage,
  usageType: data.usageType,
  fileId: (isString(data.fileId) ? data.fileId : data.fileId?.id) ?? null,
});

// TODO - delete component after featureFlag "settings_watermarks" is removed
export const getRequestOldData = (data: WatermarkFormTypeOld): UpdateWatermarkRequestBody => ({
  size: data.size,
  position: data.position as WatermarkPositionEnum,
  fitToImage: data.fitToImage.includes('fitToImage'),
  addOnlyForFirstPhoto: data.addOnlyForFirstPhoto === 'true',
  fileId: data.fileId?.id ?? null,
});
